import {toggleVisibility} from "./utils";

const swapCardsVisibility = cardId => {
  const cardBody = document.getElementById(`card_body_${cardId}`);
  const cardOrder = document.getElementById(`card_order_${cardId}`);
  toggleVisibility(cardBody);
  toggleVisibility(cardOrder);
};

export const onCardOrderPress = cardId => {
  swapCardsVisibility(cardId);
};

export const onCardBackPress = cardId => {
  swapCardsVisibility(cardId);
};



// WEBPACK FOOTER //
// ./js/searchResults.js